module.exports = __webpack_public_path__ + "static/img/vivo.4299e203.png";